function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { unionList, unionDelete, unionCreate, unionUpdate, unionDetail, unionExport, unionImport, unionGetTemplate, unionBatchDelete, unionBatchEnable, unionBatchDisable, unionStatistics, checkUnionNameExists, checkSocialCreditCodeExists } from '@/api/union';
import { fullSync, syncUnionBase, syncUnionUser } from '@/api/unionSync';
import { checkPermi } from '@/utils/permission';
export default {
  data: function data() {
    var _this = this;
    return {
      constants: this.$constants,
      loading: false,
      filterCollapse: ['1'],
      columnVisible: false,
      importVisible: false,
      query: {
        name: null,
        social_credit_code: null,
        leader: null,
        openDiscount: null,
        dateRange: [],
        page: 1,
        limit: this.$constants.page.limit[0]
      },
      listData: {
        list: [],
        total: 0
      },
      editDialog: {
        visible: false,
        isCreate: true,
        form: {}
      },
      detailDialog: {
        visible: false,
        data: {}
      },
      selectedRows: [],
      statistics: {},
      syncLoading: false,
      editRules: {
        name: [{
          required: true,
          message: '请输入工会名称',
          trigger: 'blur'
        }, {
          validator: function () {
            var _validator = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(rule, value, callback) {
              var excludeId, exists, _t;
              return _regenerator().w(function (_context) {
                while (1) switch (_context.p = _context.n) {
                  case 0:
                    if (value) {
                      _context.n = 1;
                      break;
                    }
                    return _context.a(2, callback());
                  case 1:
                    _context.p = 1;
                    excludeId = _this.editDialog.isCreate ? null : _this.editDialog.form.id;
                    _context.n = 2;
                    return checkUnionNameExists(value, excludeId);
                  case 2:
                    exists = _context.v;
                    if (exists.data) {
                      callback(new Error('工会名称已存在'));
                    } else {
                      callback();
                    }
                    _context.n = 4;
                    break;
                  case 3:
                    _context.p = 3;
                    _t = _context.v;
                    callback();
                  case 4:
                    return _context.a(2);
                }
              }, _callee, null, [[1, 3]]);
            }));
            function validator(_x, _x2, _x3) {
              return _validator.apply(this, arguments);
            }
            return validator;
          }(),
          trigger: 'blur'
        }],
        social_credit_code: [{
          validator: function () {
            var _validator2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(rule, value, callback) {
              var excludeId, exists, _t2;
              return _regenerator().w(function (_context2) {
                while (1) switch (_context2.p = _context2.n) {
                  case 0:
                    if (value) {
                      _context2.n = 1;
                      break;
                    }
                    return _context2.a(2, callback());
                  case 1:
                    _context2.p = 1;
                    excludeId = _this.editDialog.isCreate ? null : _this.editDialog.form.id;
                    _context2.n = 2;
                    return checkSocialCreditCodeExists(value, excludeId);
                  case 2:
                    exists = _context2.v;
                    if (exists.data) {
                      callback(new Error('统一社会信用代码已存在'));
                    } else {
                      callback();
                    }
                    _context2.n = 4;
                    break;
                  case 3:
                    _context2.p = 3;
                    _t2 = _context2.v;
                    callback();
                  case 4:
                    return _context2.a(2);
                }
              }, _callee2, null, [[1, 3]]);
            }));
            function validator(_x4, _x5, _x6) {
              return _validator2.apply(this, arguments);
            }
            return validator;
          }(),
          trigger: 'blur'
        }],
        discount_rate: [{
          pattern: /^(100|[1-9]?\d)(\.\d{1,2})?$/,
          message: '折扣率为0-100，最多两位小数',
          trigger: 'blur'
        }],
        leader_phone: [{
          pattern: /^1[3-9]\d{9}$/,
          message: '请输入正确的手机号',
          trigger: 'blur'
        }]
      },
      licenses: [],
      columnOptions: {
        id: 'ID',
        logo: 'Logo',
        name: '工会名称',
        abbreviation: '简称',
        social_credit_code: '信用代码',
        leader: '负责人',
        leader_phone: '负责人手机',
        billing_period: '账期',
        discount_status: '折扣状态',
        created_at: '创建时间'
      },
      selectedColumns: ['logo', 'name', 'abbreviation', 'social_credit_code', 'leader', 'leader_phone', 'billing_period', 'discount_status', 'created_at'],
      visibleColumns: {}
    };
  },
  computed: {
    editDialogTitle: function editDialogTitle() {
      return this.editDialog.isCreate ? '新增工会' : '编辑工会';
    }
  },
  mounted: function mounted() {
    this.initColumnSettings();
    this.fetchStatistics();
    this.fetchList();
  },
  methods: _defineProperty(_defineProperty({
    checkPermi: checkPermi,
    initColumnSettings: function initColumnSettings() {
      var _this2 = this;
      this.selectedColumns.forEach(function (col) {
        _this2.$set(_this2.visibleColumns, col, true);
      });
    },
    saveColumnSettings: function saveColumnSettings() {
      var _this3 = this;
      this.visibleColumns = {};
      this.selectedColumns.forEach(function (col) {
        _this3.$set(_this3.visibleColumns, col, true);
      });
      this.columnVisible = false;
    },
    fetchStatistics: function fetchStatistics() {
      var _this4 = this;
      unionStatistics().then(function (response) {
        // 根据后端返回的数据结构调整
        if (response.data) {
          _this4.statistics = response.data;
        } else {
          _this4.statistics = response || {};
        }
      }).catch(function () {
        // 如果API调用失败，使用默认数据
        _this4.statistics = {
          totalUnions: 101,
          totalMembers: 20857,
          discountUnions: 101,
          unionChange: 0
        };
      });
    },
    fetchList: function fetchList() {
      var _this5 = this;
      this.loading = true;
      var params = _objectSpread({}, this.query);
      if (params.dateRange && params.dateRange.length === 2) {
        params.beginDate = params.dateRange[0];
        params.endDate = params.dateRange[1];
      }
      delete params.dateRange;
      unionList(params).then(function (res) {
        // 根据后端返回的数据结构调整
        if (res.data && res.data.list) {
          _this5.listData = res.data;
        } else if (res.list) {
          _this5.listData = res;
        } else {
          _this5.listData = res || {
            list: [],
            total: 0
          };
        }
        _this5.loading = false;
      }).catch(function () {
        _this5.loading = false;
        _this5.listData = {
          list: [],
          total: 0
        };
      });
    },
    doSearch: function doSearch() {
      this.query.page = 1;
      this.fetchList();
    },
    resetSearch: function resetSearch() {
      this.query = {
        name: null,
        social_credit_code: null,
        leader: null,
        openDiscount: null,
        dateRange: [],
        page: 1,
        limit: this.constants.page.limit[0]
      };
      this.fetchList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.query.limit = val;
      this.fetchList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.query.page = val;
      this.fetchList();
    },
    handleSelectionChange: function handleSelectionChange(selection) {
      this.selectedRows = selection;
    },
    handleBatchAction: function handleBatchAction(command) {
      var _this6 = this;
      if (!this.selectedRows.length) {
        this.$message.warning('请先选择要操作的数据');
        return;
      }
      var ids = this.selectedRows.map(function (row) {
        return row.id;
      });
      switch (command) {
        case 'batchDelete':
          this.$confirm('确认批量删除选中的工会吗？', '提示', {
            type: 'warning'
          }).then(function () {
            unionBatchDelete(ids).then(function () {
              _this6.$message.success('批量删除成功');
              _this6.fetchList();
              _this6.fetchStatistics();
            }).catch(function () {
              _this6.$message.error('批量删除失败');
            });
          });
          break;
        case 'batchEnable':
          this.$confirm('确认批量启用选中的工会吗？', '提示', {
            type: 'warning'
          }).then(function () {
            unionBatchEnable(ids).then(function () {
              _this6.$message.success('批量启用成功');
              _this6.fetchList();
              _this6.fetchStatistics();
            }).catch(function () {
              _this6.$message.error('批量启用失败');
            });
          });
          break;
        case 'batchDisable':
          this.$confirm('确认批量禁用选中的工会吗？', '提示', {
            type: 'warning'
          }).then(function () {
            unionBatchDisable(ids).then(function () {
              _this6.$message.success('批量禁用成功');
              _this6.fetchList();
              _this6.fetchStatistics();
            }).catch(function () {
              _this6.$message.error('批量禁用失败');
            });
          });
          break;
      }
    },
    handleImportExport: function handleImportExport(command) {
      switch (command) {
        case 'export':
          this.exportList();
          break;
        case 'template':
          this.downloadTemplate();
          break;
        case 'import':
          this.importVisible = true;
          break;
      }
    },
    downloadTemplate: function downloadTemplate() {
      var _this7 = this;
      unionGetTemplate().then(function (response) {
        if (response.data && response.data.fileName) {
          // 直接使用后端返回的文件URL进行下载
          var link = document.createElement('a');
          link.href = response.data.fileName;
          link.download = '工会信息导入模板.xlsx';
          link.target = '_blank';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          _this7.$message.success('模板下载成功');
        } else {
          _this7.$message.error('获取模板下载链接失败');
        }
      }).catch(function (error) {
        console.error('下载模板失败:', error);
        _this7.$message.error('下载模板失败');
      });
    },
    beforeImport: function beforeImport(file) {
      var _this8 = this;
      var formData = new FormData();
      formData.append('file', file);
      return unionImport(formData).then(function () {
        _this8.$message.success('导入成功');
        _this8.importVisible = false;
        _this8.fetchList();
        _this8.fetchStatistics();
      });
    },
    openEdit: function openEdit(row) {
      this.editDialog.isCreate = !row;
      var init = row ? _objectSpread({}, row) : {
        openDiscount: false,
        expiredCloseDiscount: false
      };
      this.licenses = this.formatLicenses(init.licenses);
      this.editDialog.form = _objectSpread({}, init);
      this.editDialog.visible = true;
    },
    closeEdit: function closeEdit() {
      var _this9 = this;
      this.editDialog.visible = false;
      this.$nextTick(function () {
        _this9.editDialog.form = {};
        _this9.licenses = [];
      });
    },
    submitEdit: function submitEdit() {
      var _this0 = this;
      this.$refs.editForm.validate(function (valid) {
        if (!valid) return;
        var data = _objectSpread({}, _this0.editDialog.form);
        data.licensesList = _this0.licenses;
        var action = _this0.editDialog.isCreate ? unionCreate : unionUpdate;
        action(data).then(function () {
          _this0.$message.success(_this0.editDialog.isCreate ? '新增成功' : '修改成功');
          _this0.closeEdit();
          _this0.fetchList();
          _this0.fetchStatistics();
        });
      });
    },
    doDelete: function doDelete(row) {
      var _this1 = this;
      this.$confirm("\u786E\u8BA4\u5220\u9664\u5DE5\u4F1A\"".concat(row.name, "\"\u5417\uFF1F"), '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        console.log('删除工会ID:', row.id);
        unionDelete(row.id).then(function (response) {
          console.log('删除成功');
          _this1.$message.success('删除成功');
          _this1.fetchList();
          _this1.fetchStatistics();
        }).catch(function (error) {
          var _error$response, _error$response$data;
          console.error('删除失败:', error);
          _this1.$message.error('删除失败: ' + (((_error$response = error.response) === null || _error$response === void 0 ? void 0 : (_error$response$data = _error$response.data) === null || _error$response$data === void 0 ? void 0 : _error$response$data.message) || error.message || '未知错误'));
        });
      });
    },
    // 查看详情
    showDetail: function () {
      var _showDetail = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(row) {
        var response, _t3;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              _context3.n = 1;
              return unionDetail(row.id);
            case 1:
              response = _context3.v;
              this.detailDialog.data = response.data || response || {};
              this.detailDialog.visible = true;
              _context3.n = 3;
              break;
            case 2:
              _context3.p = 2;
              _t3 = _context3.v;
              console.error('获取工会详情失败:', _t3);
              this.$message.error('获取工会详情失败');
            case 3:
              return _context3.a(2);
          }
        }, _callee3, this, [[0, 2]]);
      }));
      function showDetail(_x7) {
        return _showDetail.apply(this, arguments);
      }
      return showDetail;
    }(),
    goMembers: function goMembers(row) {
      this.$router.push({
        name: 'unionMember',
        query: {
          unionId: row.id,
          unionName: row.name,
          deptId: row.deptId
        }
      });
    },
    pickLogo: function pickLogo() {
      var _this10 = this;
      this.$modalUpload(function (imgs) {
        if (imgs && imgs.length) _this10.$set(_this10.editDialog.form, 'logo', imgs[0].sattDir || imgs[0].attDir || imgs[0].url);
      }, '1', 'union');
    },
    pickLicenses: function pickLicenses() {
      var _this11 = this;
      this.$modalUpload(function (imgs) {
        var add = (imgs || []).map(function (it) {
          return it.sattDir || it.attDir || it.url;
        }).filter(Boolean);
        _this11.licenses = [].concat(_toConsumableArray(_this11.licenses), _toConsumableArray(add)).slice(0, 9);
      }, '9', 'union');
    },
    formatLicenses: function formatLicenses(val) {
      if (!val) return [];
      try {
        var arr = Array.isArray(val) ? val : JSON.parse(val);
        return arr.filter(Boolean);
      } catch (e) {
        return [];
      }
    },
    formatCreatedAt: function formatCreatedAt(row) {
      if (!row) return '-';
      var val = row.createdAt || row.created_at;
      if (!val) return '-';
      try {
        var date = new Date(val);
        if (isNaN(date.getTime())) {
          return String(val);
        }
        return date.toLocaleString();
      } catch (e) {
        return String(val);
      }
    },
    exportList: function exportList() {
      var _this12 = this;
      var params = _objectSpread({}, this.query);
      if (params.dateRange && params.dateRange.length === 2) {
        params.beginDate = params.dateRange[0];
        params.endDate = params.dateRange[1];
      }
      delete params.dateRange;
      unionExport(params).then(function (response) {
        if (response.data && response.data.fileName) {
          // 直接使用后端返回的文件URL进行下载
          var link = document.createElement('a');
          link.href = response.data.fileName;
          link.download = '工会信息.xlsx';
          link.target = '_blank';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          _this12.$message.success('导出成功');
        } else {
          _this12.$message.error('获取导出文件链接失败');
        }
      }).catch(function (error) {
        console.error('导出失败:', error);
        _this12.$message.error('导出失败');
      });
    },
    // 处理同步操作
    handleSyncAction: function handleSyncAction(command) {
      switch (command) {
        case 'fullSync':
          this.handleFullSync();
          break;
        case 'syncUnionBase':
          this.handleSyncUnionBase();
          break;
        case 'syncUnionUser':
          this.handleSyncUnionUser();
          break;
        case 'goToSyncPage':
          this.goToSyncPage();
          break;
      }
    },
    // 全量同步
    handleFullSync: function () {
      var _handleFullSync = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var _this13 = this;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              this.$confirm('确认执行全量同步？这将同步所有工会信息和会员数据。', '同步确认', {
                type: 'warning',
                confirmButtonText: '确认同步',
                cancelButtonText: '取消'
              }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
                var result, _t4;
                return _regenerator().w(function (_context4) {
                  while (1) switch (_context4.p = _context4.n) {
                    case 0:
                      _this13.syncLoading = true;
                      _context4.p = 1;
                      _context4.n = 2;
                      return fullSync();
                    case 2:
                      result = _context4.v;
                      _this13.$message.success(result.msg || '全量同步任务已启动，请查看日志了解执行结果');
                      // 同步完成后刷新统计数据和列表
                      setTimeout(function () {
                        _this13.fetchStatistics();
                        _this13.fetchList();
                      }, 2000);
                      _context4.n = 4;
                      break;
                    case 3:
                      _context4.p = 3;
                      _t4 = _context4.v;
                      _this13.$message.error('全量同步失败：' + _t4.message);
                    case 4:
                      _context4.p = 4;
                      _this13.syncLoading = false;
                      return _context4.f(4);
                    case 5:
                      return _context4.a(2);
                  }
                }, _callee4, null, [[1, 3, 4, 5]]);
              }))).catch(function () {
                _this13.$message.info('已取消同步操作');
              });
            case 1:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function handleFullSync() {
        return _handleFullSync.apply(this, arguments);
      }
      return handleFullSync;
    }(),
    // 同步工会基本信息
    handleSyncUnionBase: function () {
      var _handleSyncUnionBase = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var _this14 = this;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              this.$confirm('确认同步工会基本信息？', '同步确认', {
                type: 'info',
                confirmButtonText: '确认同步',
                cancelButtonText: '取消'
              }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
                var result, _t5;
                return _regenerator().w(function (_context6) {
                  while (1) switch (_context6.p = _context6.n) {
                    case 0:
                      _this14.syncLoading = true;
                      _context6.p = 1;
                      _context6.n = 2;
                      return syncUnionBase();
                    case 2:
                      result = _context6.v;
                      _this14.$message.success(result.msg || '工会基本信息同步任务已启动');
                      // 同步完成后刷新统计数据和列表
                      setTimeout(function () {
                        _this14.fetchStatistics();
                        _this14.fetchList();
                      }, 1500);
                      _context6.n = 4;
                      break;
                    case 3:
                      _context6.p = 3;
                      _t5 = _context6.v;
                      _this14.$message.error('工会基本信息同步失败：' + _t5.message);
                    case 4:
                      _context6.p = 4;
                      _this14.syncLoading = false;
                      return _context6.f(4);
                    case 5:
                      return _context6.a(2);
                  }
                }, _callee6, null, [[1, 3, 4, 5]]);
              }))).catch(function () {
                _this14.$message.info('已取消同步操作');
              });
            case 1:
              return _context7.a(2);
          }
        }, _callee7, this);
      }));
      function handleSyncUnionBase() {
        return _handleSyncUnionBase.apply(this, arguments);
      }
      return handleSyncUnionBase;
    }(),
    // 同步工会用户数据
    handleSyncUnionUser: function () {
      var _handleSyncUnionUser = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
        var _this15 = this;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              this.$confirm('确认同步工会用户数据？', '同步确认', {
                type: 'info',
                confirmButtonText: '确认同步',
                cancelButtonText: '取消'
              }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
                var result, _t6;
                return _regenerator().w(function (_context8) {
                  while (1) switch (_context8.p = _context8.n) {
                    case 0:
                      _this15.syncLoading = true;
                      _context8.p = 1;
                      _context8.n = 2;
                      return syncUnionUser();
                    case 2:
                      result = _context8.v;
                      _this15.$message.success(result.msg || '工会用户数据同步任务已启动');
                      // 同步完成后刷新统计数据
                      setTimeout(function () {
                        _this15.fetchStatistics();
                      }, 1500);
                      _context8.n = 4;
                      break;
                    case 3:
                      _context8.p = 3;
                      _t6 = _context8.v;
                      _this15.$message.error('工会用户数据同步失败：' + _t6.message);
                    case 4:
                      _context8.p = 4;
                      _this15.syncLoading = false;
                      return _context8.f(4);
                    case 5:
                      return _context8.a(2);
                  }
                }, _callee8, null, [[1, 3, 4, 5]]);
              }))).catch(function () {
                _this15.$message.info('已取消同步操作');
              });
            case 1:
              return _context9.a(2);
          }
        }, _callee9, this);
      }));
      function handleSyncUnionUser() {
        return _handleSyncUnionUser.apply(this, arguments);
      }
      return handleSyncUnionUser;
    }(),
    // 跳转到高级同步设置页面
    goToSyncPage: function goToSyncPage() {
      this.$router.push({
        name: 'unionSync'
      });
    }
  }, "formatLicenses", function formatLicenses(licenses) {
    if (!licenses) return [];
    if (typeof licenses === 'string') {
      try {
        return JSON.parse(licenses);
      } catch (e) {
        return [];
      }
    }
    return Array.isArray(licenses) ? licenses : [];
  }), "closeDetail", function closeDetail() {
    var _this16 = this;
    this.detailDialog.visible = false;
    this.$nextTick(function () {
      _this16.detailDialog.data = {};
    });
  })
};